import React, { Component, PropTypes } from 'react';
import { getTopOffset, getLeftOffset } from '../../utils/getOffsetTop';
import css from './dropdown.scss';

export const TOP_RIGHT    = 'TOP_RIGHT';
export const TOP_LEFT     = 'TOP_LEFT';
export const BOTTOM_RIGHT = 'BOTTOM_RIGHT';
export const BOTTOM_LEFT  = 'BOTTOM_LEFT';
export const AUTO         = 'AUTO';

export default class Dropdown extends Component {
	static propTypes = {
		attachTo: PropTypes.func.isRequired,
		height: PropTypes.number,
		width: PropTypes.number,
		pointTo: PropTypes.string,
	};

	static defaultProps = {
		height: 0,
		width: 260,
		pointTo: TOP_RIGHT,
	};

	constructor(props) {
		super();
		this.mounted = true;

		this.setActive = this.setActive.bind(this);
		this.setInactive = this.setInactive.bind(this);
		this.toggleActive = this.toggleActive.bind(this);

		this.state = {
			active: false,
			fading: false,
			...this.getClientRect(props),
			maxWidth: this.getMaxWidth(),
		};
	}

	componentDidMount() {
		let attachElement = this.props.attachTo();
		this.addListener(attachElement);
		//this.addListener(this.refs.dropdown);
	}

	componentWillUnmount() {
		this.mounted = false;
		let attachElement = this.props.attachTo();
		this.removeListener(attachElement);
		//this.removeListener(this.refs.dropdown);
	}

	componentWillUpdate(nextProps, nextState) {}

	componentWillReceiveProps(nProps) {
		if (
			this.mounted &&
			this.props.browser.window.width !== nProps.browser.window.width ||
			this.props.browser.window.height !== nProps.browser.window.height
		) {
			this.mounted && this.setState({
				...this.state,
				...this.getClientRect(this.props),
				maxWidth: this.getMaxWidth(),
			});
		}
	}

	getClientRect(props) {
		return {
			clientRect: props.attachTo() ? props.attachTo().getClientRects()[0] : false,
		};
	}

	componentDidUpdate(prevProps, prevState) {}

	render() {
		let styles = {};
		let attachElement = this.props.attachTo();
		let className = 'dropdown';
		let arrowClassName = 'dropdown__arrow';
		let arrowOffset = 30;
		let arrowUp = true;
		let arrowLeft = true;
		let wCenterX = window.innerWidth / 2;
		let wCenterY = window.innerHeight / 2;
		let width = parseInt(this.props.width, 10);
		let maxWidth = this.state.maxWidth;
		let correctionStyle = {
			marginLeft: 0,
		};
		let clientRect = this.state.clientRect;

		// if (attachElement) {
		// 	clientRect = attachElement.getClientRects()[0];
		// }

		if (clientRect && clientRect.width) {
			let eHalfWidth = (clientRect.width / 2);
			let eHalfHeight = (clientRect.height / 2);
			let eCenterX = clientRect.left + eHalfWidth;
			let eCenterY = clientRect.top + eHalfHeight;

			arrowLeft = (eCenterX < wCenterX);
			arrowUp = (eCenterY < wCenterY);

			if (arrowLeft) {
				styles.left = (attachElement.offsetLeft - arrowOffset + eHalfWidth) + 'px';
				arrowClassName += ' dropdown__arrow--left';
			} else {
				styles.left = (attachElement.offsetLeft - (this.props.width - arrowOffset - eHalfWidth)) + 'px';
				arrowClassName += ' dropdown__arrow--right';
			}

			if (arrowUp) {
				styles.top = (attachElement.offsetTop + clientRect.height) + 'px';
				arrowClassName += ' dropdown__arrow--top';
			} else {
				styles.bottom = (attachElement.offsetParent.offsetHeight - attachElement.offsetTop) + 'px';
				correctionStyle.bottom = '0px';
				//styles.bottom = '100%';//getTopOffset(attachElement);
				//styles.marginBottom = (clientRect.height - attachElement.offsetTop) + 'px';
				arrowClassName += ' dropdown__arrow--bottom';
			}

			if (this.props.height) {
				styles.height = parseInt(this.props.height, 10) + 'px';
			}

			if (this.props.width) {
				styles.width = (width > maxWidth ? maxWidth : width)  + 'px';
			}

			// console.log(`(${wCenterX} < ${(width > maxWidth ? maxWidth : width)})`);
			if (wCenterX < (width > maxWidth ? maxWidth : width)) {
				let dropWidth = (width > maxWidth ? maxWidth : width);
				//let outWidth = (dropWidth - wCenterX);
				let realOutWidth = 0;

				if (arrowLeft) {
					//realOutWidth = dropWidth - (clientRect.left + arrowOffset);
					//correctionStyle.left = realOutWidth + 'px';
					//correctionStyle.right = outWidth + 'px';
					//styles.left = -outWidth + 'px';
				} else {
					realOutWidth = (clientRect.left + -arrowOffset) - dropWidth;
					correctionStyle.left = -realOutWidth + 'px';

					//styles.left = (dropWidth - (dropWidth - outWidth)) + 'px';
				}

				//console.log('out: ' + realOutWidth);
			}
		} else {
			setTimeout(() => {
				this.mounted && this.setState({
					...this.state,
					...this.getClientRect(this.props),
				});
			}, 100);
		}

		correctionStyle.width = styles.width;

		if (this.state.active) {
			className += ' dropdown--active';
		}

		return (
			<div ref='dropdown'>
				{this.state.active && (
					<div className='dropdown__dimmer' onClick={this.setInactive.bind(this)}></div>
				)}
				<div className={className} style={styles} ref='dropdown'>
					{arrowUp && (<div className={arrowClassName}></div>)}

					<div className='dropdown__repositioner' style={correctionStyle}>
						{(arrowUp && !this.props.disablePattern) && (<div className='dropdown__grid pixel-pattern pixel-pattern--darker pixel-pattern--01'></div>)}

						<div className='dropdown__content' onClick={this.setInactive.bind(this)}>
							{this.props.children}
						</div>

						{(!arrowUp && !this.props.disablePattern) && (<div className='dropdown__grid dropdown__grid--bottom pixel-pattern pixel-pattern--darker pixel-pattern--01'></div>)}
					</div>

					{!arrowUp && (<div className={arrowClassName}></div>)}
				</div>
			</div>
		);
	}

	addListener(element) {
		if (element && typeof element.addEventListener === 'function') {
			//element.addEventListener('mouseenter', this.setActive);
			//element.addEventListener('mouseleave', this.setInactive);
			element.addEventListener('click', this.toggleActive);
		}
	}

	removeListener(element) {
		if (element && typeof element.removeEventListener === 'function') {
			//element.removeEventListener('mouseenter', this.setActive);
			//element.removeEventListener('mouseleave', this.setInactive);
			element.removeEventListener('click', this.toggleActive);
		}
	}

	setActive() {
		//clearTimeout(this.graceTimer);
		//this.state.active = true;
		this.setAttachElementActiveClass(true);
		this.setState({
			...this.state,
			active: true,
		});
	}

	setInactive() {
		this.setAttachElementActiveClass(false);
		this.setState({
			...this.state,
			active: false,
		});
	}

	toggleActive() {
		this.setAttachElementActiveClass(!this.state.active);

		this.setState({
			...this.state,
			active: !this.state.active,
		});
	}

	setAttachElementActiveClass(active) {
		let attachElement = this.props.attachTo();
		attachElement.classList[active ? 'add' : 'remove']('dropdown-activator--active');
	}

	getMaxWidth() {
		if (document.documentElement && document.documentElement.clientWidth) {
			return document.documentElement.clientWidth - 40;
		}

		if (document.body) {
			return document.body.clientWidth - 40;
		}

		return 0;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/dropdown/dropdown.js
 **/